<template>
  <v-footer dark padless>
    <v-card width="100%" flat tile class="azulfuerte lighten-1 white--text text-center">
      <v-card-text>
        <v-btn v-for="icon in icons" :key="icon.text" class="mx-4 white--text" icon :href="icon.link">
          <v-icon size="24px">
            {{ icon.text }}
          </v-icon>
        </v-btn>
      </v-card-text>

      <v-btn color="white" @click="$goToSection('seccionPreguntas','/')" depressed plain>
        Preguntas frecuentes
      </v-btn>

      <v-btn color="white" depressed plain :href="WhatsApp">
        CONTACTO WHATSAPP {{ this.getCookie }}
      </v-btn>

      <!-- Modal aviso privacidad simplificado -->
      <v-dialog  v-model="dialog" scrollable transition="dialog-bottom-transition" max-width="600">
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="white" depressed plain v-bind="attrs" v-on="on">
            Aviso de privacidad
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="text-h5 grey lighten-3 font-weight-bold">
            Aviso de privacidad
          </v-card-title>

          <v-card-text style="max-height: 400px; overflow-y: auto; padding: 16px;">
            <p>
              En Medicover cuidamos tu privacidad. Tratamos tus datos personales conforme a la ley y con medidas de seguridad adecuadas.
              Consulta el aviso completo en nuestra
              <a href="https://www.medicover.com.mx/aviso-privacidad" target="_blank">página web</a>.
            </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="grey lighten-3 justify-end">
            <v-btn color="primary" text @click="dialog = false">
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-divider></v-divider>

      <v-card-text class="white--text">
        © {{ new Date().getFullYear() }} MediCover. Todos los derechos reservados.
      </v-card-text>

      <!-- Snackbar cookies menos invasivo -->
      <v-snackbar v-if="!this.getCookie" v-model="dialogcookies" color="#5f98ca" timeout="-1" bottom multi-line>
        <div class="white--text text-body-2">
          Utilizamos <strong>cookies</strong> para personalizar contenido, mostrar anuncios y analizar el tráfico. Al continuar navegando, aceptas su uso.
        </div>
        <template v-slot:action="{ attrs }">
          <v-btn text color="white" v-bind="attrs" @click="aceptarcookies">
            Aceptar
          </v-btn>
        </template>
      </v-snackbar>
    </v-card>
  </v-footer>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AppFooter',
  computed: {
    ...mapGetters(['getCookie'])
  },
  methods: {
    aceptarcookies() {
      this.dialogcookies = false;
      this.$store.commit('ACCEPT_COOKIE', 'accept');
    }
  },
  data: () => ({
    WhatsApp: `https://wa.me/send?phone=${process.env.VUE_APP_BASE_PHONEWHATSWEB}&text=${encodeURIComponent('Web Hola, ')}`,
    dialog: false,
    dialogcookies: true,
    icons: [
      {
        text: 'mdi-facebook',
        link: 'https://www.facebook.com/MediCoverMX'
      },
      {
        text: 'mdi-twitter',
        link: ''
      },
      {
        text: 'mdi-linkedin',
        link: ''
      },
      {
        text: 'mdi-instagram',
        link: 'https://www.instagram.com/medicover.mx/'
      },
      {
        text: 'mdi-google-maps',
        link: 'https://maps.app.goo.gl/W3R7P5kmr3TknQaa8'
      }
    ]
  })
}
</script>

<style scoped>
</style>
